export default "__VITE_ASSET__CoAHzYfy__"